import { ErrorMessage, Field, useFieldArray } from 'vee-validate';
import PlusSVG from '../../icons/PlusSVG.vue';


export default {
  __name: 'NIPField',
  setup(__props, { expose }) {
  expose();

const { fields, remove, push } = useFieldArray('nip');

if (fields.value.length === 0) {
  push({ value: '' });
}

const __returned__ = { fields, remove, push, get ErrorMessage() { return ErrorMessage }, get Field() { return Field }, get useFieldArray() { return useFieldArray }, PlusSVG }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}